// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textblock {
    flex-direction: row;
    display: flex;
    white-space: pre-wrap;
}

.defaultGroupHeader {
    border-top: 1px solid silver;
    flex: 1 1 auto;
    align-self: center;
    margin-left: 4px;
}

.settingsGroupHeader {
    margin-top: 11px;
    margin-bottom: 7px;
    border-bottom: 1px solid #E2E4E7;
    background: #F0F2F5;
    padding: 4px;
    font-weight: bold;
    text-align: left;
    font-size: 11px;
    width:100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/scripteditor/scripteditor.control.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd","sourcesContent":[".textblock {\n    flex-direction: row;\n    display: flex;\n    white-space: pre-wrap;\n}\n\n.defaultGroupHeader {\n    border-top: 1px solid silver;\n    flex: 1 1 auto;\n    align-self: center;\n    margin-left: 4px;\n}\n\n.settingsGroupHeader {\n    margin-top: 11px;\n    margin-bottom: 7px;\n    border-bottom: 1px solid #E2E4E7;\n    background: #F0F2F5;\n    padding: 4px;\n    font-weight: bold;\n    text-align: left;\n    font-size: 11px;\n    width:100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
